import { Validator } from '@vista-digital/validator';
/**
 * Media type options for the Film Thumbnail component.
 */
export var FilmThumbnailMediaType;
(function (FilmThumbnailMediaType) {
    FilmThumbnailMediaType["Poster"] = "Poster";
    FilmThumbnailMediaType["Still"] = "Still";
    FilmThumbnailMediaType["Backdrop"] = "Backdrop";
})(FilmThumbnailMediaType || (FilmThumbnailMediaType = {}));
export const filmThumbnailMediaTypeValidator = Validator.oneOf(Object.values(FilmThumbnailMediaType));
